export default __webpack_public_path__ + "media/images/logo-e69e27883692f07bce4210d87d19c7b3.svg";